import { render, staticRenderFns } from "./dashboardcapital.vue?vue&type=template&id=58165bbe&scoped=true&"
import script from "./dashboardcapital.vue?vue&type=script&lang=js&"
export * from "./dashboardcapital.vue?vue&type=script&lang=js&"
import style0 from "./dashboardcapital.vue?vue&type=style&index=0&id=58165bbe&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58165bbe",
  null
  
)

export default component.exports